import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { CheckedListControl2 } from "@/Common/Components/Inputs/CheckedListControl2";
import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { SettingsButton } from "@/Common/Components/Settings/SettingsButton";
import { SearchMenuHelper } from "@/Common/Helpers/SearchMenuHelper";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ILabsActionInboxModel } from "@/Labs/Models/UI/ILabsActionInboxModel";

import "./LabActionsInboxSettingsContainer.css";

interface ILabActionsInboxSettingsContainerProps {
    model: ILabsActionInboxModel;

    onContainerClick: () => void;
    id?: string;
    className?: string;
    style?: React.CSSProperties;
}

class LabActionsInboxSettingsContainer extends BaseReactComponent<ILabActionsInboxSettingsContainerProps> {
    public componentDidMount(): void {
        this.setOverlay(
            "LabActionsInboxSettingsContainer",
            {
                transparent: true,
                onClicked: () => this.props.onContainerClick()
            }
        );
    }

    public render(): JSX.Element {
        const prescriptorSearchText = this.props.model.get("CliniciansPrescriptorSearchText").trim();
        const clinicianActionSearchText = this.props.model.get("CliniciansActionBySearchText").trim();

        const prescriptorClinicians = this.filterText(prescriptorSearchText, this.props.model.get("PrescriptorClinicians"));
        const actionByClinicians = this.filterText(clinicianActionSearchText, this.props.model.get("ActionByClinicians"));

        return (
            <div id={this.props.id} className={this.props.className} style={this.props.style}>
                <table className="f-content">
                    <thead>
                        <tr>
                            <th className="first">
                                <label style={{ display: "inline" }}>{cacheStore.GetString("DateLabel").toUpperCase()}</label>
                            </th>
                            {this.props.model.get("Sites").count() > 1 && (
                                <th>
                                    <CheckboxControl
                                        id="sites_check"
                                        label={cacheStore.GetString("SitesLabel").toUpperCase()}
                                        operation={LocalOperations.Labs.LabActionsInboxSearchSettings_CheckboxChange}
                                        checked={this.props.model.get("SelectAllSitesChecked")}
                                        target={CheckboxTarget.Myle_Labs_SitesControlCheck}
                                    />
                                </th>
                            )}

                            <th className="last">
                                <CheckboxControl
                                    id="AllPrescriptorclinicians_check"
                                    label={cacheStore.GetString("PrescribedByLabel").toUpperCase()}
                                    operation={LocalOperations.Labs.LabActionsInboxSearchSettings_CheckboxChange}
                                    checked={this.props.model.get("SelectAllCliniciansPrescriptorChecked")}
                                    target={CheckboxTarget.Myle_Labs_AllCliniciansPrescriptorControlCheck}
                                />
                            </th>
                            <th>
                                <CheckboxControl
                                    id="AllActionByclinicians_check"
                                    label={cacheStore.GetString("ActionTaken").toUpperCase()}
                                    operation={LocalOperations.Labs.LabActionsInboxSearchSettings_CheckboxChange}
                                    checked={this.props.model.get("SelectAllCliniciansActionByChecked")}
                                    target={CheckboxTarget.Myle_Labs_AllCliniciansActionByControlCheck}
                                />
                            </th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="first">
                                <MultiDateSelector
                                    id="doc_search_date_selector"
                                    fromMyleOperation={LocalOperations.Labs.LabActionsInboxSearchSettings_FromDateChanged}
                                    toMyleOperation={LocalOperations.Labs.LabActionsInboxSearchSettings_ToDateChanged}
                                    fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    from={this.props.model.get("DateFrom")}
                                    to={this.props.model.get("DateTo")}
                                />
                            </td>
                            {this.props.model.get("Sites").count() > 1 && (
                                <td className="sites-column">
                                    <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto" }}>
                                        <CheckedListControl
                                            DataSource={this.props.model.get("Sites")}
                                            Operation={LocalOperations.Labs.LabActionsInboxSearchSettings_CheckboxChange}
                                            MaxTextLength={25}
                                        />
                                    </div>
                                </td>
                            )}

                            <td style={{ width: "227px" }}>
                                <input className="form-control" style={{ width: "225px" }} type="text" value={this.props.model.get("CliniciansPrescriptorSearchText")} onChange={e => this.onClinitianPrescriptorsFilterTextChanged(e)} placeholder={cacheStore.GetString("SearchLabel").toUpperCase()} />
                                <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto" }}>
                                    <CheckedListControl2
                                        DataSource={prescriptorClinicians}
                                        Operation={LocalOperations.Labs.LabActionsInboxSearchSettings_CheckboxChange}
                                        sort
                                        limitTextWidth
                                    />
                                </div>
                            </td>
                            <td>
                                <input className="form-control" style={{ width: "225px" }} type="text" value={this.props.model.get("CliniciansActionBySearchText")} onChange={e => this.onClinitiansActionsByFilterTextChanged(e)} placeholder={cacheStore.GetString("SearchLabel").toUpperCase()} />
                                <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto" }}>
                                    <CheckedListControl2
                                        DataSource={actionByClinicians}
                                        Operation={LocalOperations.Labs.LabActionsInboxSearchSettings_CheckboxChange}
                                        sort
                                        limitTextWidth
                                    />
                                </div>
                            </td>
                            <td className="last" />
                        </tr>
                    </tbody>
                </table>

                <div className="f-footer clearfix f-footer-responsive-labaction">
                    <div className="pull-left">
                        <SettingsButton
                            alternativeIcon
                            rightMargin={5}
                            onClickOperation={LocalOperations.Labs.LabActionsInboxColumnOrderingPopup_Open}
                        />
                    </div>

                    <div className="pull-right flex-display flex-gap-xs">
                        <ButtonControl
                            className="btn btn-default"
                            onClick={() => sessionStore.dispatch(LocalOperations.Labs.LabActionsInboxSearchSettings_OnCancelClick)}
                            label={cacheStore.GetString("CancelLabel")}
                        />
                        <ButtonControl
                            className="btn btn-primary"
                            onClick={() => sessionStore.dispatch(LocalOperations.Labs.LabActionsInboxSearchSettings_OnOkClick)}
                            label={cacheStore.GetString("Ok_Label")}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private onClinitiansActionsByFilterTextChanged(event: React.ChangeEvent<HTMLInputElement>): void {
        sessionStore.dispatch(
            LocalOperations.Labs.LabActionsInboxSearchSettings_ClinicianActionByFilterTextChanged,
            {
                value: event.target.value
            }
        );
    }

    private onClinitianPrescriptorsFilterTextChanged(event: React.ChangeEvent<HTMLInputElement>): void {
        sessionStore.dispatch(
            LocalOperations.Labs.LabActionsInboxSearchSettings_ClinicianPrescriptorFilterTextChanged,
            {
                value: event.target.value
            }
        );
    }

    private filterText(str: string, fullList: Immutable.List<EmployeeUIModel>): Immutable.List<EmployeeUIModel> {
        return str
            ? SearchMenuHelper.FilterCliniciansByName(str, fullList)
            : fullList;
    }
}

export { LabActionsInboxSettingsContainer };
